import type { UpdateProfileInput } from '@noconflict/contracts';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { supabase } from '../../shared/api/supabase';
import { getOwnProfile, updateProfile } from './api';

export const profileKeys = { own: (userId: string) => ['profile', userId] as const };

export function useOwnProfile(userId: string | undefined) {
  return useQuery({
    queryKey: profileKeys.own(userId ?? ''),
    queryFn: () => getOwnProfile(supabase, userId ?? ''),
    enabled: Boolean(userId),
  });
}

export function useUpdateProfile(userId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateProfileInput) => updateProfile(supabase, input),
    onSuccess: (profile) => qc.setQueryData(profileKeys.own(userId), profile),
  });
}
